/* eslint-disable no-restricted-globals, import/named */
import {
  fetchPoisOfTripUrl,
  fetchPoiDetailFromItineraryUrl,
  fetchTextNoteUrl,
  fetchMyTripListUrl,
  fetchTravelGroupListUrl,
  editAliasNameUrl,
  oneMoreDayUrl,
  postTextNoteUrl,
  updateStartTimeUrl,
  updateStayTimeUrl,
  reindexDaySequenceUrl,
  reindexPoiSequenceUrl,
  copyPoiUrl,
  deletePoiUrl,
  removeDaysUrl,
  createTripUrl,
  deleteTripUrl,
  copyTripUrl,
  getCountOfInvitationsUrl,
  acceptSendItineraryUrl,
  acceptSharedTripUrl,
  deleteSharedTripUrl,
  customizeTransportationTimeUrl,
  addPoiToTripUrl,
  addPoiToCollectionsUrl,
  fetchMyCollectionListUrl,
  fetchPoiDetailFromCollectionUrl,
  fetchSharedCollectionsFoldersUrl
} from '../utilities/url_util';
import {
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAIL,
  FETCH_POIS,
  FETCH_POI_DETAIL_SUCCESS,
  FETCH_POI_DETAIL_FAIL,
  FETCH_POI_DETAIL,
  FETCH_TEXT_NOTE_SUCCESS,
  FETCH_TEXT_NOTE_FAIL,
  FETCH_TEXT_NOTE,
  FETCH_MY_TRIP_LIST_SUCCESS,
  FETCH_MY_TRIP_LIST_FAIL,
  FETCH_MY_TRIP_LIST,
  FETCH_TRAVEL_GROUP_LIST_SUCCESS,
  FETCH_TRAVEL_GROUP_LIST_FAIL,
  FETCH_TRAVEL_GROUP_LIST,
  ERASE_TRIP_LIST,
  UPDATE_TRIP_INFO,
  UPDATE_TRIP_INFO_SUCCESS,
  UPDATE_TRIP_INFO_FAIL,
  EDIT_ALIAS_NAME,
  EDIT_ALIAS_NAME_SUCCESS,
  EDIT_ALIAS_NAME_FAIL,
  ONE_MORE_DAY,
  ONE_MORE_DAY_SUCCESS,
  ONE_MORE_DAY_FAIL,
  POST_TEXT_NOTE,
  POST_TEXT_NOTE_SUCCESS,
  POST_TEXT_NOTE_FAIL,
  UPDATE_START_TIME,
  UPDATE_START_TIME_SUCCESS,
  UPDATE_START_TIME_FAIL,
  UPDATE_STAY_TIME,
  UPDATE_STAY_TIME_SUCCESS,
  UPDATE_STAY_TIME_FAIL,
  REINDEX_DAY_SEQUENCE,
  REINDEX_DAY_SEQUENCE_SUCCESS,
  REINDEX_DAY_SEQUENCE_FAIL,
  REINDEX_POI_SEQUENCE,
  REINDEX_POI_SEQUENCE_SUCCESS,
  REINDEX_POI_SEQUENCE_FAIL,
  COPY_POI,
  COPY_POI_SUCCESS,
  COPY_POI_FAIL,
  REMOVE_POIS,
  REMOVE_POIS_SUCCESS,
  REMOVE_POIS_FAIL,
  REMOVE_DAYS,
  REMOVE_DAYS_SUCCESS,
  REMOVE_DAYS_FAIL,
  ADD_TRIP,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_FAIL,
  COPY_TRIP,
  COPY_TRIP_FAIL,
  COPY_TRIP_SUCCESS,
  DELETE_TRIP,
  DELETE_TRIP_SUCCESS,
  DELETE_TRIP_FAIL,
  DELETE_SHARED_TRIP,
  DELETE_SHARED_TRIP_SUCCESS,
  DELETE_SHARED_TRIP_FAIL,
  GET_COUNT_OF_INVITATIONS,
  GET_COUNT_OF_INVITATIONS_SUCCESS,
  GET_COUNT_OF_INVITATIONS_FAIL,
  ACCEPT_SEND_ITINERARY,
  ACCEPT_SEND_ITINERARY_SUCCESS,
  ACCEPT_SEND_ITINERARY_FAIL,
  ACCEPT_SHARED_TRIP,
  ACCEPT_SHARED_TRIP_SUCCESS,
  ACCEPT_SHARED_TRIP_FAIL,
  CUSTOMIZE_TRANSPORTATION_TIME,
  CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
  CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
  ADD_POI,
  ADD_POI_SUCCESS,
  ADD_POI_FAIL,
  REMOVE_MEMBER_FROM_GROUP_OF_MY_TRIPS,
  FETCH_TRIPS_COMMENTS_LOADING,
  FETCH_TRIPS_COMMENTS_SUCCESS,
  FETCH_TRIPS_COMMENTS_FAIL,
  ADD_POI_TO_COLLECTIONS_SUCCESS,
  ADD_POI_TO_COLLECTIONS,
  ADD_POI_TO_COLLECTIONS_FAIL,
  FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL,
  FETCH_MY_COLLECTIONS,
  FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS,
  FETCH_MY_COLLECTIONS_SUCCESS,
  FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL,
  FETCH_MY_COLLECTIONS_FAIL,
  FETCH_SHARED_COLLECTIONS_FOLDERS,
  FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS,
  FETCH_MY_COLLECTIONS_IN_FOLDER,
  RESET_MY_TRIP_LIST,
  COPY_TRIP_FROM_ITINERARY,
  RESET_DATE_OUT_STATUS,
  RESET_POST_TRIP_PUBLIC_STATUS,
  MORE_DAYS,
  MORE_DAYS_SUCCESS,
  MORE_DAYS_FAIL
} from './action_types';
import {
  VIEW_STATE_ITINERARY,
  VIEW_STATE_MY_TRIPS
} from '../reducers/view_state';
import { getClientId } from '../utilities/uuid_util';
import {
  TRANSPORTATION_TYPE_DRIVING_FROM_WEB,
  DATA_SOURCE_POI_BANK_NEXT,
  DATA_SOURCE_CUSTOM_POI
} from '../utilities/constants';
import { getBasicParameters } from '../utilities/parameter_util';
import { thumbnailImageUrlForPostByPhotoResult } from '../utilities/convert_poi_util';
import { funlidayRequest } from '../apis/main';
import { socialGetCommentList, socialCopy } from '../apis/social';
import { SOCIAL_TYPE } from '../constants/social';
import { updateV2Trip } from '../apis/trips';
import { CODE_MESSAGE } from '../constants/response';

export const fetchPois = tripObjectId => {
  const url = fetchPoisOfTripUrl();
  return dispatch => {
    dispatch({ type: FETCH_POIS, payload: { tripObjectId } });
    const parameters = getBasicParameters();
    parameters.parseTripObjectId = tripObjectId;
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_POIS_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          console.error('fetchPois -> error', response.data);
          dispatch({
            type: FETCH_POIS_FAIL,
            payload: { status, tripObjectId, errorMessage: message }
          });
        }
      })
      .catch(error => {
        console.error('fetchPois -> error', error);
        dispatch({
          type: FETCH_POIS_FAIL,
          payload: { status: '404', tripObjectId, errorMessage: error.message }
        });
      });
  };
};

// fetch poi detail request
export const fetchPoiDetailFromItinerary = (
  tripObjectId,
  poiObjectId,
  type
) => {
  const url = fetchPoiDetailFromItineraryUrl();
  return dispatch => {
    dispatch({ type: FETCH_POI_DETAIL, payload: { poiObjectId, type } });
    const parameters = getBasicParameters();
    parameters.parseTripObjectId = tripObjectId;
    parameters.parsePoiObjectId = poiObjectId;
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_POI_DETAIL_SUCCESS,
            payload: { status, poiObjectId, results, type }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_POI_DETAIL_FAIL,
            payload: { status, poiObjectId, errorMessage: message, type }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_POI_DETAIL_FAIL,
          payload: {
            status: '404',
            poiObjectId,
            errorMessage: error.message,
            type
          }
        });
      });
  };
};

// fetch text note request
export const fetchTextNote = (tripObjectId, poiObjectId) => {
  const url = fetchTextNoteUrl();
  return dispatch => {
    dispatch({ type: FETCH_TEXT_NOTE, payload: { poiObjectId } });
    const parameters = getBasicParameters();
    parameters.parseTripObjectId = tripObjectId;
    parameters.parsePoiObjectId = poiObjectId;
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_TEXT_NOTE_SUCCESS,
            payload: { status, poiObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_TEXT_NOTE_FAIL,
            payload: { status, poiObjectId, errorMessage: message }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_TEXT_NOTE_FAIL,
          payload: { status: '404', poiObjectId, errorMessage: error.message }
        });
      });
  };
};

export const fetchMyTripList = (accessToken, memberObjectId, skip, limit) => {
  const parameters = {
    ...getBasicParameters(),
    skip: skip.toString(),
    limit: limit.toString()
  };

  const url = fetchMyTripListUrl();
  return dispatch => {
    dispatch({ type: FETCH_MY_TRIP_LIST, payload: { memberObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_MY_TRIP_LIST_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_MY_TRIP_LIST_FAIL,
            payload: { status, memberObjectId, errorMessage: message }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_MY_TRIP_LIST_FAIL,
          payload: {
            status: '404',
            memberObjectId,
            errorMessage: error.message
          }
        });
      });
  };
};

export const resetMyTripList = () => ({
  type: RESET_MY_TRIP_LIST
});

export const fetchTravelGroupList = (
  accessToken,
  memberObjectId,
  skip,
  limit
) => {
  const parameters = {
    ...getBasicParameters(),
    skip: skip.toString(),
    limit: limit.toString()
  };

  const url = fetchTravelGroupListUrl();
  return dispatch => {
    dispatch({ type: FETCH_TRAVEL_GROUP_LIST, payload: { memberObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_TRAVEL_GROUP_LIST_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_TRAVEL_GROUP_LIST_FAIL,
            payload: { status, memberObjectId, errorMessage: message }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_MY_TRIP_LIST_FAIL,
          payload: {
            status: '404',
            memberObjectId,
            errorMessage: error.message
          }
        });
      });
  };
};

export const eraseTripList = (state, parameters) => ({
  type: ERASE_TRIP_LIST
});

export const updateTripDate = ({
  tripId,
  revision,
  start,
  end,
  originDaysCount
}) => {
  const tripObjectId = tripId;
  return async dispatch => {
    dispatch({ type: MORE_DAYS, payload: { tripObjectId } });
    try {
      const response = await updateV2Trip({
        tripId,
        revision,
        start_date: start,
        end_date: end
      });

      if (response.data.code_message === CODE_MESSAGE.SUCCESS) {
        const data = response?.data?.data;
        const { day_count, start_date_timestamp, revision: newRevision } = data;
        dispatch({
          type: MORE_DAYS_SUCCESS,
          payload: {
            tripObjectId,
            originDaysCount,
            dayCount: String(day_count),
            start: String(start_date_timestamp),
            revision: newRevision
          }
        });
      } else {
        dispatch({ type: MORE_DAYS_FAIL, payload: { tripObjectId } });
      }
    } catch (error) {
      dispatch({ type: MORE_DAYS_FAIL, payload: { tripObjectId } });
    }
  };
};

export const updateTripInfo = ({
  tripObjectId,
  tripName,
  revision,
  startDate,
  endDate,
  isTripName,
  userCities
}) => {
  const parameters = {
    ...getBasicParameters(),
    tripId: tripObjectId,
    revision,
    name: tripName,
    start_date: startDate,
    end_date: endDate,
    user_cities: userCities
  };

  return async dispatch => {
    dispatch({
      type: UPDATE_TRIP_INFO,
      payload: {
        tripObjectId,
        tripName,
        isTripName,
        revision,
        startDate,
        endDate,
        userCities
      }
    });
    try {
      const response = await updateV2Trip(parameters);

      const results = response.data;
      if (response.data.code_message === CODE_MESSAGE.SUCCESS) {
        dispatch({
          type: UPDATE_TRIP_INFO_SUCCESS,
          payload: { status: 200, tripObjectId, isTripName, results }
        });
      } else {
        const { status, message } = response.data;
        dispatch({
          type: UPDATE_TRIP_INFO_FAIL,
          payload: {
            status,
            tripObjectId,
            isTripName,
            revision,
            errorMessage: message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_TRIP_INFO_FAIL,
        payload: {
          status: '404',
          tripObjectId,
          isTripName,
          revision,
          errorMessage: error.message,
          toastViewState: VIEW_STATE_ITINERARY
        }
      });
    }
  };
};

export const editAliasName = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  aliasName
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    aliasName
  };

  const url = editAliasNameUrl();
  return dispatch => {
    dispatch({ type: EDIT_ALIAS_NAME, payload: { tripObjectId, poiObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: EDIT_ALIAS_NAME_SUCCESS,
            payload: { status, tripObjectId, poiObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: EDIT_ALIAS_NAME_FAIL,
            payload: {
              status,
              tripObjectId,
              poiObjectId,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: EDIT_ALIAS_NAME_FAIL,
          payload: {
            status: '404',
            tripObjectId,
            poiObjectId,
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const oneMoreDay = (
  accessToken,
  memberObjectId,
  tripObjectId,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    revision
  };

  const url = oneMoreDayUrl();
  return dispatch => {
    dispatch({ type: ONE_MORE_DAY, payload: { tripObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: ONE_MORE_DAY_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: ONE_MORE_DAY_FAIL,
            payload: {
              status,
              tripObjectId,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: EDIT_ALIAS_NAME_FAIL,
          payload: {
            status: '404',
            tripObjectId,
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const postTextNote = (
  {
    accessToken,
    memberObjectId,
    tripObjectId,
    poiObjectId,
    textNoteObjectId,
    text
  },
  callBack
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    textNote: text
  };
  if (textNoteObjectId) {
    if (textNoteObjectId.length > 0) {
      parameters.textNoteObjectId = textNoteObjectId;
    }
  }

  const url = postTextNoteUrl();
  return dispatch => {
    dispatch({ type: POST_TEXT_NOTE, payload: { poiObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: POST_TEXT_NOTE_SUCCESS,
            payload: {
              status,
              poiObjectId,
              results: {
                ...results,
                parsePoiObjectId: poiObjectId,
                text,
                shouldSyncWithServer: false
              }
            }
          });
          callBack('Done');
        } else {
          const { status, message } = response.data;
          dispatch({
            type: POST_TEXT_NOTE_FAIL,
            payload: { status, poiObjectId, errorMessage: message }
          });
          callBack('Oops! Connection error...');
        }
      })
      .catch(error => {
        dispatch({
          type: EDIT_ALIAS_NAME_FAIL,
          payload: { status: '404', tripObjectId, errorMessage: error.message }
        });
        callBack('Oops! Connection error...');
      });
  };
};

export const updateStartTime = (
  accessToken,
  memberObjectId,
  tripObjectId,
  startTime,
  daySequence,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    startTime,
    daySequence,
    revision
  };

  const url = updateStartTimeUrl();
  return dispatch => {
    dispatch({ type: UPDATE_START_TIME, payload: { tripObjectId, startTime } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: UPDATE_START_TIME_SUCCESS,
            payload: { status, tripObjectId, startTime, results }
          });
        } else {
          const { message } = response.data;
          dispatch({
            type: UPDATE_START_TIME_FAIL,
            payload: {
              status,
              tripObjectId,
              startTime,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: UPDATE_START_TIME_FAIL,
          payload: {
            status: '404',
            tripObjectId,
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const updateStayTime = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  stayTime,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    stayTime,
    revision
  };

  const url = updateStayTimeUrl();
  return dispatch => {
    dispatch({
      type: UPDATE_STAY_TIME,
      payload: { tripObjectId, poiObjectId, stayTime }
    });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: UPDATE_STAY_TIME_SUCCESS,
            payload: { status, tripObjectId, poiObjectId, stayTime, results }
          });
        } else {
          const { message } = response.data;
          dispatch({
            type: UPDATE_STAY_TIME_FAIL,
            payload: {
              status,
              tripObjectId,
              poiObjectId,
              stayTime,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: UPDATE_START_TIME_FAIL,
          payload: { status: '404', tripObjectId, errorMessage: error.message }
        });
      });
  };
};

export const reindexDaySequence = (
  accessToken,
  memberObjectId,
  tripObjectId,
  fromDaySequence,
  toDaySequence,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    fromDaySequence,
    toDaySequence,
    revision
  };

  const url = reindexDaySequenceUrl();
  return dispatch => {
    dispatch({ type: REINDEX_DAY_SEQUENCE, payload: { tripObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: REINDEX_DAY_SEQUENCE_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: REINDEX_DAY_SEQUENCE_FAIL,
            payload: {
              tripObjectId,
              toastViewState: VIEW_STATE_ITINERARY,
              status
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: REINDEX_DAY_SEQUENCE_FAIL,
          payload: { tripObjectId, toastViewState: VIEW_STATE_ITINERARY }
        });
      });
  };
};

export const reindexPoiSequence = ({
  memberObjectId,
  tripObjectId,
  poiObjectId,
  fromDaySequence,
  toDaySequence,
  fromPoiSequenceIndex,
  toPoiSequenceIndex,
  revision
}) => {
  const parameters = {
    deviceId: getClientId(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    fromDaySequence,
    toDaySequence,
    fromPoiSequenceIndex,
    toPoiSequenceIndex,
    revision
  };

  const url = reindexPoiSequenceUrl();
  return dispatch => {
    dispatch({ type: REINDEX_POI_SEQUENCE, payload: { poiObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: REINDEX_POI_SEQUENCE_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: REINDEX_POI_SEQUENCE_FAIL,
            payload: {
              status,
              poiObjectId,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        console.error('error', error);
        dispatch({
          type: REINDEX_POI_SEQUENCE_FAIL,
          payload: {
            poiObjectId,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const copyPoi = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  poiSequenceIndex,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    poiSequenceIndex,
    revision
  };

  const url = copyPoiUrl();
  return dispatch => {
    dispatch({ type: COPY_POI, payload: { poiObjectId } });

    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: COPY_POI_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: COPY_POI_FAIL,
            payload: {
              status,
              poiObjectId,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        // console.log('copyPoi exception =', error.message);
        dispatch({
          type: COPY_POI_FAIL,
          payload: {
            poiObjectId,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const deletePois = (tripObjectId, idArray, revision) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    idArray,
    revision
  };

  const url = deletePoiUrl();
  return dispatch => {
    dispatch({ type: REMOVE_POIS, payload: { tripObjectId } });
    // console.log(' delete pois parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('deletePois =', response);
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: REMOVE_POIS_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: REMOVE_POIS_FAIL,
            payload: {
              status,
              tripObjectId,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        // console.log('deletePois exception =', error.message);
        dispatch({
          type: REMOVE_POIS_FAIL,
          payload: {
            tripObjectId,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const removeDays = (
  accessToken,
  memberObjectId,
  tripObjectId,
  dayArray,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    dayArray,
    revision
  };

  const url = removeDaysUrl();
  return dispatch => {
    dispatch({ type: REMOVE_DAYS, payload: { tripObjectId } });
    // console.log(' remove days parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('removeDays =', response);
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: REMOVE_DAYS_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: REMOVE_DAYS_FAIL,
            payload: {
              status,
              tripObjectId,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        // console.log('removeDays exception =', error.message);
        dispatch({
          type: REMOVE_DAYS_FAIL,
          payload: {
            tripObjectId,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const createTrip = (
  accessToken,
  memberObjectId,
  tripName,
  startDate,
  endDate,
  dayCount,
  coverNumber
) => {
  const parameters = {
    ...getBasicParameters(),
    tripName,
    startDate,
    endDate,
    dayCount,
    coverNumber
  };

  const url = createTripUrl();
  return dispatch => {
    dispatch({ type: ADD_TRIP, payload: { memberObjectId } });
    // console.log(' create trip parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('createTrip =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: ADD_TRIP_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          dispatch({
            type: ADD_TRIP_FAIL,
            payload: {
              memberObjectId,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        // console.log('createTrip exception =', error.message);
        dispatch({
          type: ADD_TRIP_FAIL,
          payload: {
            memberObjectId,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

// copyTrip from journal
export const copyJournalTrip = ({
  accessToken,
  memberObjectId,
  tripName,
  startDate,
  journalId,
  parseTripObjectId
}) => {
  const url = copyTripUrl();
  const parameters = {
    ...getBasicParameters(),
    tripName,
    startDate,
    journalId,
    parseTripObjectId
  };
  return dispatch => {
    dispatch({ type: COPY_TRIP, payload: { memberObjectId } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: COPY_TRIP_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          dispatch({
            type: COPY_TRIP_FAIL,
            payload: {
              memberObjectId,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: COPY_TRIP_FAIL,
          payload: {
            memberObjectId,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

export const deleteTrip = (accessToken, memberObjectId, tripObjectId) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId
  };

  const url = deleteTripUrl();
  return dispatch => {
    dispatch({ type: DELETE_TRIP, payload: { tripObjectId } });
    // console.log(' delete trip parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('delete trip =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: DELETE_TRIP_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: DELETE_TRIP_FAIL,
            payload: {
              tripObjectId,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        // console.log('delete trip exception =', error.message);
        dispatch({
          type: ADD_TRIP_FAIL,
          payload: {
            tripObjectId,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

export const deleteSharedTrip = (accessToken, memberObjectId, tripObjectId) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId
  };

  const url = deleteSharedTripUrl();
  return dispatch => {
    dispatch({ type: DELETE_SHARED_TRIP, payload: { tripObjectId } });
    // console.log(' delete shared trip parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('delete shared trip =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: DELETE_SHARED_TRIP_SUCCESS,
            payload: { status, tripObjectId, results }
          });
        } else {
          dispatch({
            type: DELETE_SHARED_TRIP_FAIL,
            payload: {
              tripObjectId,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        // console.log('delete shared trip exception =', error.message);
        dispatch({
          type: DELETE_SHARED_TRIP_FAIL,
          payload: {
            tripObjectId,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

export const getCountOfInvitations = (accessToken, memberObjectId) => {
  const parameters = {
    ...getBasicParameters()
  };

  const url = getCountOfInvitationsUrl();
  return dispatch => {
    dispatch({ type: GET_COUNT_OF_INVITATIONS, payload: { memberObjectId } });
    // console.log(' getCountOfInvitations parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('getCountOfInvitations =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: GET_COUNT_OF_INVITATIONS_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          dispatch({
            type: GET_COUNT_OF_INVITATIONS_FAIL,
            payload: { memberObjectId }
          });
        }
      })
      .catch(error => {
        // console.log('getCountOfInvitations exception =', error.message);
        dispatch({
          type: GET_COUNT_OF_INVITATIONS_FAIL,
          payload: { memberObjectId }
        });
      });
  };
};

export const acceptSendItinerary = (
  accessToken,
  memberObjectId,
  tripObjectId,
  objectId,
  accept,
  startDate
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    objectId,
    accept: accept === true ? '1' : '0'
  };
  if (accept === true) {
    parameters.startDate = startDate;
  }

  const url = acceptSendItineraryUrl();
  return dispatch => {
    dispatch({ type: ACCEPT_SEND_ITINERARY, payload: { objectId, accept } });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('acceptSendItinerary =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: ACCEPT_SEND_ITINERARY_SUCCESS,
            payload: {
              status,
              memberObjectId,
              objectId,
              accept,
              results,
              toastMessage: accept
                ? 'This trip has been added to "My Trips"'
                : 'You have declined to join this travel group.',
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        } else {
          dispatch({
            type: ACCEPT_SEND_ITINERARY_FAIL,
            payload: {
              objectId,
              accept,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        // console.log('acceptSendItinerary exception =', error.message);
        dispatch({
          type: ACCEPT_SEND_ITINERARY_FAIL,
          payload: {
            objectId,
            accept,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

export const acceptSharedTrip = (
  accessToken,
  memberObjectId,
  tripObjectId,
  accept
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    accept: accept === true ? '1' : '0'
  };

  const url = acceptSharedTripUrl();
  return dispatch => {
    dispatch({
      type: ACCEPT_SHARED_TRIP,
      payload: { objectId: tripObjectId, accept }
    });
    // console.log(' acceptSharedTrip parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('acceptSharedTrip =', response);
        const { status, results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: ACCEPT_SHARED_TRIP_SUCCESS,
            payload: {
              status,
              memberObjectId,
              objectId: tripObjectId,
              accept,
              results,
              toastMessage: accept
                ? 'This trip has been added to "Travel Groups"'
                : 'You have declined to join this travel group.',
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        } else {
          dispatch({
            type: ACCEPT_SHARED_TRIP_FAIL,
            payload: {
              objectId: tripObjectId,
              accept,
              toastViewState: VIEW_STATE_MY_TRIPS
            }
          });
        }
      })
      .catch(error => {
        // console.log('acceptSharedTrip exception =', error.message);
        dispatch({
          type: ACCEPT_SHARED_TRIP_FAIL,
          payload: {
            objectId: tripObjectId,
            accept,
            toastViewState: VIEW_STATE_MY_TRIPS
          }
        });
      });
  };
};

export const sendCustomizeTransportationTime = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  flag,
  time,
  revision
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    customizeTransportationTimeFlag: flag,
    customizeTransportationTime: time,
    revision
  };

  const url = customizeTransportationTimeUrl();
  return dispatch => {
    dispatch({ type: CUSTOMIZE_TRANSPORTATION_TIME, payload: { poiObjectId } });
    // console.log(' customizeTransportationTime parameters = ', parameters);
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        // console.log('customizeTransportationTime =', response);
        const { status, results } = response.data;
        if (status === '200') {
          dispatch({
            type: CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
            payload: { status, poiObjectId, results }
          });
        } else {
          dispatch({
            type: CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
            payload: {
              status,
              poiObjectId,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        // console.log('customizeTransportationTime exception =', error.message);
        dispatch({
          type: CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
          payload: {
            poiObjectId,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};

export const addPoiToTrip =
  ({
    tripObjectId,
    daySequence,
    revision,
    poi,
    addToCollections,
    poiBankToken,
    language,
    actionAt
  }) =>
  dispatch => {
    const parameters = {
      ...getBasicParameters(),
      parseTripObjectId: tripObjectId,
      daySequence: daySequence.toString(),
      revision
    };

    parameters.transportationType = TRANSPORTATION_TYPE_DRIVING_FROM_WEB;
    parameters.addToCollections = addToCollections ? '1' : '0'; // 自建景點用的 別被 addToCollections 名稱誤導 一般不自建景點就帶 0

    const {
      photo,
      poiBankNextId,
      poiDetail: {
        address,
        name,
        location,
        customPoiFlag,
        phoneNumber,
        website,
        categories,
        duration
      },
      dataSource
    } = poi;
    // poi id
    if (poiBankNextId) parameters.poiBankNextId = poiBankNextId;
    // address
    if (address) parameters.address = address;
    // name
    if (name) parameters.name = name;
    // location
    if (location) parameters.location = location;
    // dataSource
    if (dataSource) parameters.dataSource = dataSource;

    // set data source to custom poi if custom poi flag is '1'
    if (customPoiFlag === '1') {
      parameters.dataSource = DATA_SOURCE_CUSTOM_POI;
    }

    // categories
    if (categories) parameters.categories = categories;
    // thumbnail image(poi bank)
    if (photo)
      parameters.thumbnailUrl = thumbnailImageUrlForPostByPhotoResult(photo);
    // categories
    if (duration && Number(duration) > 0)
      parameters.stayTime = String(duration);

    // info for poi bank
    if (
      dataSource === DATA_SOURCE_POI_BANK_NEXT ||
      dataSource === DATA_SOURCE_CUSTOM_POI
    ) {
      const postObject = {};
      if (poiBankToken) postObject.token = poiBankToken;
      if (language) postObject.language = language;
      if (dataSource === DATA_SOURCE_POI_BANK_NEXT) {
        postObject.data = [
          { id: String(poiBankNextId), actionAt: String(actionAt) }
        ];
      } else if (dataSource === DATA_SOURCE_CUSTOM_POI) {
        if (name) postObject.name = name;
        postObject.data = [{ id: address, actionAt: String(actionAt) }];
      }

      parameters.infoForPoiBank = postObject;
    }

    if (dataSource === DATA_SOURCE_CUSTOM_POI) {
      if (phoneNumber) parameters.phoneNumber = phoneNumber;
      if (website) parameters.website = website;
    }

    // legacy code, should remove in the future
    if (dataSource !== DATA_SOURCE_POI_BANK_NEXT) {
      const {
        poiId,
        poiBankId,
        poiDetail: {
          photoReference,
          internationalPhoneNumber,
          openingHours,
          blogUrl,
          photos,
          photoUrl
        }
      } = poi;

      if (poiId) parameters.poiId = poiId;
      // legacy poi bank
      if (poiBankId) parameters.poiBankId = poiBankId;
      // photo reference
      if (photoReference) parameters.photoReference = photoReference;
      // phoneNumber
      if (phoneNumber) parameters.phoneNumber = phoneNumber;
      // internationalPhoneNumber
      if (internationalPhoneNumber)
        parameters.internationalPhoneNumber = internationalPhoneNumber;
      // openingHours
      if (openingHours) parameters.openingHours = openingHours;
      // website
      if (website) parameters.website = website;
      // blogUrl
      if (blogUrl) parameters.blogUrl = blogUrl;
      // photos ??????
      if (photos) parameters.photos = photos;
      // photoUrl
      if (photoUrl) parameters.photoUrl = photoUrl;
    }

    const url = addPoiToTripUrl();
    dispatch({ type: ADD_POI, payload: { tripObjectId } });

    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { status, results } = response.data;
        console.log('🚀 ~ file: trip_action.js ~ line 1532 ~ status', status);
        if (status === '200') {
          dispatch({
            type: ADD_POI_SUCCESS,
            payload: {
              status,
              tripObjectId,
              results,
              toastMessage: 'Added to itinerary',
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        } else {
          dispatch({
            type: ADD_POI_FAIL,
            payload: {
              tripObjectId,
              toastViewState: VIEW_STATE_ITINERARY,
              status
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: ADD_POI_FAIL,
          payload: {
            tripObjectId,
            toastViewState: VIEW_STATE_ITINERARY,
            status
          }
        });
      });
  };

export const removeMemberFromGroupOfMyTrips =
  (memberID, tripID) => dispatch => {
    dispatch({
      type: REMOVE_MEMBER_FROM_GROUP_OF_MY_TRIPS,
      payload: {
        memberID,
        tripID
      }
    });
  };

export const getTripsComments = (id, userid) => dispatch => {
  dispatch({
    type: FETCH_TRIPS_COMMENTS_LOADING
  });
  socialGetCommentList({ userid, id, type: SOCIAL_TYPE.TRIP }).then(
    response => {
      if (response.status !== 200 || response.data.status !== '200') {
        dispatch({
          type: FETCH_TRIPS_COMMENTS_FAIL,
          payload: {
            errorMessage: 'Oops! Connection error...',
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      } else {
        const { results } = response.data;
        dispatch({
          type: FETCH_TRIPS_COMMENTS_SUCCESS,
          payload: {
            data: results.data,
            dataNext: results.data_next
          }
        });
      }
    }
  );
};

// fetch poi detail request
export const addPoiToCollections =
  ({ memberObjectId, poi, poiBankToken, language, actionAt }) =>
  dispatch => {
    dispatch({ type: ADD_POI_TO_COLLECTIONS, payload: { memberObjectId } });
    const parameters = {};
    // console.log(' add poi to colletion poi = ', poi);
    const {
      poiBankNextId,
      dataSource,
      poiDetail: {
        address,
        name,
        location,
        customPoiFlag,
        phoneNumber,
        website,
        categories
      }
    } = poi;
    // poi id
    if (poiBankNextId) parameters.poiBankNextId = poiBankNextId;
    // address
    if (address) parameters.address = address;
    // name
    if (name) parameters.name = name;
    // location
    if (location) parameters.location = location;
    // dataSource
    if (dataSource) parameters.dataSource = dataSource;
    if (customPoiFlag === '1') {
      parameters.dataSource = DATA_SOURCE_CUSTOM_POI;
    }

    // categories
    if (categories) parameters.categories = categories;
    // info for poi bank
    if (
      dataSource === DATA_SOURCE_POI_BANK_NEXT ||
      dataSource === DATA_SOURCE_CUSTOM_POI
    ) {
      const postObject = {};
      if (poiBankToken) postObject.token = poiBankToken;
      if (language) postObject.language = language;
      if (dataSource === DATA_SOURCE_POI_BANK_NEXT) {
        postObject.data = [
          { id: String(poiBankNextId), actionAt: String(actionAt) }
        ];
      } else if (dataSource === DATA_SOURCE_CUSTOM_POI) {
        if (name) postObject.name = name;
        postObject.data = [{ id: address, actionAt: String(actionAt) }];
      }
      parameters.infoForPoiBank = postObject;
    }

    if (dataSource === DATA_SOURCE_CUSTOM_POI) {
      if (phoneNumber) parameters.phoneNumber = phoneNumber;
      if (website) parameters.website = website;
    }

    // legacy code, should remove in the future
    if (dataSource !== DATA_SOURCE_POI_BANK_NEXT) {
      const {
        poiId,
        poiBankId,
        poiDetail: {
          photoReference,
          internationalPhoneNumber,
          openingHours,
          blogUrl,
          photos,
          photoUrl
        }
      } = poi;

      if (poiId) parameters.poiId = poiId;
      // legacy poi bank
      if (poiBankId) parameters.poiBankId = poiBankId;
      // photo reference
      if (photoReference) parameters.photoReference = photoReference;
      // phoneNumber
      if (phoneNumber) parameters.phoneNumber = phoneNumber;
      // internationalPhoneNumber
      if (internationalPhoneNumber)
        parameters.internationalPhoneNumber = internationalPhoneNumber;
      // openingHours
      if (openingHours) parameters.openingHours = openingHours;
      // website
      if (website) parameters.website = website;
      // blogUrl
      if (blogUrl) parameters.blogUrl = blogUrl;
      // photos ??????
      if (photos) parameters.photos = photos;
      // photoUrl
      if (photoUrl) parameters.photoUrl = photoUrl;
    }

    const url = addPoiToCollectionsUrl();
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: ADD_POI_TO_COLLECTIONS_SUCCESS,
            payload: {
              status,
              memberObjectId,
              results,
              toastMessage: 'Added to collections',
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: ADD_POI_TO_COLLECTIONS_FAIL,
            payload: {
              status,
              memberObjectId,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: ADD_POI_TO_COLLECTIONS_FAIL,
          payload: {
            status: '404',
            memberObjectId,
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };

export const fetchMyCollectionList = (
  accessToken,
  memberObjectId,
  folderObjectId,
  skip,
  limit
) => {
  const parameters = {
    ...getBasicParameters(),
    skip: skip.toString(),
    limit: limit.toString()
  };
  if (folderObjectId) {
    parameters.collectionsFolderObjectId = folderObjectId;
  }

  const url = fetchMyCollectionListUrl();
  return dispatch => {
    dispatch({
      type: folderObjectId
        ? FETCH_MY_COLLECTIONS_IN_FOLDER
        : FETCH_MY_COLLECTIONS,
      payload: { memberObjectId, skip: skip.toString(), folderObjectId }
    });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          const type = folderObjectId
            ? FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS
            : FETCH_MY_COLLECTIONS_SUCCESS;
          const payload = { status, memberObjectId, folderObjectId, results };

          dispatch({
            type,
            payload
          });
        } else {
          const { status, message } = response.data;
          const type = folderObjectId
            ? FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL
            : FETCH_MY_COLLECTIONS_FAIL;
          const payload = {
            status,
            memberObjectId,
            errorMessage: message,
            toastViewState: VIEW_STATE_ITINERARY,
            folderObjectId
          };

          dispatch({
            type,
            payload
          });
        }
      })
      .catch(error => {
        const type = folderObjectId
          ? FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL
          : FETCH_MY_COLLECTIONS_FAIL;
        const payload = {
          status: '404',
          memberObjectId,
          errorMessage: error.message,
          toastViewState: VIEW_STATE_ITINERARY,
          folderObjectId
        };

        dispatch({
          type,
          payload
        });
      });
  };
};

export const fetchSharedCollectionsFolderList = (
  accessToken,
  memberObjectId,
  skip,
  limit
) => {
  const parameters = {
    ...getBasicParameters(),
    skip: skip.toString(),
    limit: limit.toString()
  };
  const url = fetchSharedCollectionsFoldersUrl();
  return dispatch => {
    dispatch({
      type: FETCH_SHARED_COLLECTIONS_FOLDERS,
      payload: { memberObjectId, skip: skip.toString() }
    });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS,
            payload: { status, memberObjectId, results }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL,
            payload: {
              status,
              memberObjectId,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL,
          payload: {
            status: '404',
            memberObjectId,
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      });
  };
};
// fetch poi detail request
export const fetchPoiDetailFromCollection = (
  folderObjectId,
  poiObjectId,
  type
) => {
  const url = fetchPoiDetailFromCollectionUrl();
  return dispatch => {
    dispatch({
      type: FETCH_POI_DETAIL,
      payload: { folderObjectId, poiObjectId, type }
    });
    const parameters = getBasicParameters();
    parameters.parseCollectionObjectId = poiObjectId;

    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_POI_DETAIL_SUCCESS,
            payload: { status, folderObjectId, poiObjectId, results, type }
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_POI_DETAIL_FAIL,
            payload: {
              status,
              folderObjectId,
              poiObjectId,
              errorMessage: message,
              type
            }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_POI_DETAIL_FAIL,
          payload: {
            status: '404',
            folderObjectId,
            poiObjectId,
            errorMessage: error.message,
            type
          }
        });
      });
  };
};

export const resetSocialCopyRequestStatus = () => ({
  type: COPY_TRIP_FROM_ITINERARY.INIT
});

export const copyTripFromItinerary =
  ({ userID, id, name, startDate }) =>
  dispatch => {
    dispatch({ type: COPY_TRIP_FROM_ITINERARY.LOADING });
    return socialCopy({
      userid: userID,
      id,
      type: SOCIAL_TYPE.TRIP,
      name,
      startDate
    })
      .then(respose => {
        if (respose.data.status === '200') {
          dispatch({ type: COPY_TRIP_FROM_ITINERARY.SUCCESS });
        } else {
          console.log(respose.data);
          dispatch({ type: COPY_TRIP_FROM_ITINERARY.FAIL });
        }
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: COPY_TRIP_FROM_ITINERARY.FAIL });
      });
  };

export const resetDataOutStatus = () => ({ type: RESET_DATE_OUT_STATUS });

export const resetTripRequestStatus = () => ({
  type: RESET_POST_TRIP_PUBLIC_STATUS
});
